import { apiConstants } from "../../../../utils/apiConstants";
import { apiTypes } from "../../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../../utils/getAxiosCancelToken";
import apiRequestType from "../../../apiRequestType";

let cancelToken;

const getFilterClassDistributionSummary = (data) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.POST,
    apiConstants.REPORT.GRAPHICAL_REPORT.FILTER_CLASS_DISTRIBUTION_SUMMARY,
    data,
    cancelToken
  );
};
export default getFilterClassDistributionSummary;
